import { render, staticRenderFns } from "./KpiTrackingDetails.vue?vue&type=template&id=ff9b88fe&scoped=true&"
import script from "./KpiTrackingDetails.vue?vue&type=script&lang=js&"
export * from "./KpiTrackingDetails.vue?vue&type=script&lang=js&"
import style0 from "./KpiTrackingDetails.vue?vue&type=style&index=0&id=ff9b88fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9b88fe",
  null
  
)

export default component.exports